/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class ReturnOrderApi {
    static getInstance() {
        if (!this.instance) this.instance = new ReturnOrderApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 获取退货杂单列表
    async getReturnOrderList (param, num, size){
        let url = `/api/order/back/record/list?page_num=${num}&page_size=${size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 创建退货杂单
    async createReturnOrder (param, id, type){
        let url = `/api/order/back/record/${id}?type=${type}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取产品列表
    async getProductList (param){
        let url = `/api/product/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 保存备注
    async saveComment(param){
        let url = `/api/order/back/record/${param.id}/instruction`
        let result = await this.getData(url,param,'GET')
        return result
    }

}

export {
    ReturnOrderApi
}